/**
 * 包含一些零碎的业务的路由
 */
import { loadPageFail } from '../lib/units';

export default [{
        name: 'commentPage',
        path: '/comment/:status',
        meta: {
            title: function() {
                let rs = '';
                if (this.params.status == 'write') {
                    rs = '发表评价页';
                } else {
                    rs = '我的评价页';
                }
                return rs;
            },
        },
        component: resolve => require(['../pages/show/comment/comment'], resolve, (err) => {
            loadPageFail({
                pagename: '发表/查看评价页',
                err
            })
        })
    },
    {
        name: 'commentSuccessPage',
        path: '/commentSuccess/:status',
        meta: {
            title: '评价成功页'
        },
        component: resolve => require(['../pages/show/comment/commentSuccess'], resolve, (err) => {
            loadPageFail({
                pagename: '评价成功页',
                err
            })
        })
    },
    {
        name: 'commentListPage',
        path: '/commentList/:id',
        meta: {
            title: '全部评价页'
        },
        component: resolve => require(['../pages/show/comment/commentList'], resolve, (err) => {
            loadPageFail({
                pagename: '全部评价页',
                err
            });
        })
    },
    {
        name: 'doFirstEnd',
        path: '/doFirstEnd/:status',
        meta: {
            title: '先做题看报告中转页'
        },
        component: resolve => require(['../pages/doFirstEnd'], resolve, (err) => {
            loadPageFail({
                pagename: '先做题看报告中转页',
                err
            });
        })
    },
    {
        name: 'packIntroduce',
        path: '/buyCombo/:comboId/channelId/:channelId/orderId/:orderId',
        meta: {
            title: '套餐购买成功页',
        },
        component: resolve => require(['../pages/show/combo/comboIntroduce.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '套餐购买成功页',
                err
            });
        }),
    },
    {
        name: 'myGift',
        path: '/mineGift/:status',
        meta: {
            title: '赠礼管理',
            fullTitle: function() {
                let rs = '赠礼管理';
                if (this.params.status == 0) {
                    rs += '-我送出的';
                } else if (this.params.status == 1) {
                    rs += '-我收到的';
                }

                return rs;
            }
        },
        component: resolve => require(['../pages/show/gift/mineGift.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '赠礼管理页',
                err
            });
        }),
    },
    {
        name: 'consultOrder',
        path: '/consultOrder',
        meta: {
            title: '填写咨询信息页'
        },
        component: resolve => require(['../pages/consult/consultOrder'], resolve, (err) => {
            loadPageFail({
                pagename: '填写咨询信息页',
                err
            });
        })
    },
    {
        name: 'consultSucceed',
        path: '/consultSucceed',
        meta: {
            title: '信息提交成功页'
        },
        component: resolve => require(['../pages/consult/consultSucceed'], resolve, (err) => {
            loadPageFail({
                pagename: '信息提交成功页',
                err
            });
        })
    },
    {
        name: 'testDistribution',
        path: '/testDistribution',
        meta: {
            title: '分享赚钱页'
        },
        component: resolve => require(['../pages/show/testDistribution'], resolve, (err) => {
            loadPageFail({
                pagename: '分享赚钱页',
                err
            });
        })
    },
    {
        name: 'myTrack',
        path: '/myTrack',
        meta: {
            title: '个人中心-足迹列表',
            fullTitle: function() {
                return '个人中心-足迹列表';
            }
        },
        component: resolve => require(['../pages/show/myTrack.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '个人中心-足迹列表',
                err
            });
        })
    },
    {
        name: 'pangu',
        path: '/pangu',
        meta: {
            title: '盘古登录',
            fullTitle: function() {
                return '盘古登录';
            }
        },
        component: resolve => require(['../pages/show/pangu.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '盘古登录',
                err
            });
        })
    },
    {
        name: 'shareCard',
        path: '/shareCard',
        meta: {
            title: '壹心理|疫区公益心理援助专线',
            fullTitle: function() {
                return '壹心理|疫区公益心理援助专线';
            }
        },
        component: resolve => require(['../pages/fragmemt/shareCard.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '壹心理|疫区公益心理援助专线',
                err
            });
        })
    },
    {
        name: 'myConsult',
        path: '/myConsult',
        meta: {
            title: '我的咨询订单页',
            fullTitle: function() {
                return '我的咨询订单页';
            }
        },
        component: resolve => require(['../pages/show/myConsult.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '我的咨询订单页',
                err
            });
        }),
    },
    {
      name: 'customerService',
      path: '/customerService',
      meta: {
          title: '客服消息页',
          fullTitle: function() {
              return '客服消息页';
          }
      },
      component: resolve => require(['../pages/fragmemt/customerService.vue'], resolve, (err) => {
          loadPageFail({
              pagename: '客服消息页',
              err
          });
      }),
    },
    {
        name: 'paymentYxlZixunSuccess',
        path: '/paymentYxlZixunSuccess',
        meta: {
            title: '成功购买咨询页',
            fullTitle: function() {
                return '成功购买咨询页';
            }
        },
        component: resolve => require(['../pages/consult/payment-yxl-zixun-success.vue'], resolve, (err) => {
            loadPageFail({
                pagename: '成功购买咨询页',
                err
            });
        })
    },
]


// WEBPACK FOOTER //
// ./src/router/fragment.js